/**
 * Marketplace Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const marketplaceRoutes: RouteRecordRaw[] = [
    {
        path: '/marketplace/subscribe',
        name: 'MarketplaceSubscribe',
        component: () => import('./views/MarketplaceIndexPage.vue'),
        meta: {
            title: 'Available Services',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/my-subscriptions',
        name: 'MySubscriptions',
        component: () => import('./views/MySubscriptionsPage.vue'),
        meta: {
            title: 'My Subscriptions',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/onzla',
        name: 'OnzlaService',
        component: () => import('./views/OnzlaServicePage.vue'),
        meta: {
            title: 'Onzla Ventures',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/spc-migration',
        name: 'SpcMigrationService',
        component: () => import('./views/SpcMigrationServicePage.vue'),
        meta: {
            title: 'SPC Migration',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/s2000-migration',
        name: 'S2000MigrationService',
        component: () => import('./views/S2000MigrationServicePage.vue'),
        meta: {
            title: 'S2000 Migration',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/my-preset',
        name: 'MyPresetManage',
        component: () => import('./mypreset/views/MyPresetManagePage.vue'),
        meta: {
            title: 'My Preset',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/custom-sender-email',
        name: 'CustomSenderEmail',
        component: () => import('./customSenderEmail/views/CustomSenderEmailPage.vue'),
        meta: {
            title: 'Custom Sender Email',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/tax-savy',
        name: 'TaxSavyService',
        component: () => import('./views/TaxSavyServicePage.vue'),
        meta: {
            title: 'Tax Savy',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/:id',
        name: 'MarketplaceDetail',
        component: () => import('./views/MarketplaceDetailPage.vue'),
        meta: {
            title: 'Marketplace Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/marketplace/subscriptions/:subscriptionId/entities',
        name: 'SubscriptionEntity',
        component: () => import('./views/SubscriptionEntityPage.vue'),
        meta: {
            title: 'Subscription Entity Management',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 기존 /marketplace 경로를 /marketplace/subscribe로 리다이렉트
    {
        path: '/marketplace',
        redirect: '/marketplace/subscribe',
    },
];

export default marketplaceRoutes;
